export class SamplingSuppliesCategory {

    constructor(public id: number,
        public name: string,
        public childCategories: SamplingSuppliesCategory[]) {
    }
}
